import { getResponseBodyEditorContent } from '../../utils/responseBody';
import { TOOL_BODY_MAX_CHARS } from './aiChatConstants';

// NOTE (COMMS-16 history): the streaming-idle watchdog that lived here died
// with the Phoenix AI channel. A BYO-key turn is ONE non-streamed HTTP call
// through the Rust client, which owns the timeout (utils/tauri.js
// timeout_secs → lib.rs, clamped) — the promise always settles, so an
// event-idle watchdog would only misfire on long-but-healthy turns that
// emit nothing until they finish.

/** Normalize a Tauri / adapter HTTP response into a clean tool result for AI + UI. */
export function formatSendRequestResult(raw) {
  const response = {
    status: raw.status,
    status_text: raw.status_text || raw.statusText || '',
    headers: raw.headers || {},
    data: raw.data ?? raw.body ?? '',
    time: raw.time ?? raw.time_ms,
    size: raw.size,
  };

  const { text: formattedBody, language } = getResponseBodyEditorContent(response);

  let body = formattedBody;
  if (language === 'json') {
    try {
      body = JSON.parse(formattedBody);
    } catch {
      body = formattedBody;
    }
  }

  if (typeof body === 'string') {
    if (body.length > TOOL_BODY_MAX_CHARS) {
      body = `${body.slice(0, TOOL_BODY_MAX_CHARS)}\n… (truncated)`;
    }
  } else if (body !== null && typeof body === 'object') {
    const serialized = JSON.stringify(body);
    if (serialized.length > TOOL_BODY_MAX_CHARS) {
      body = { _truncated: true, preview: `${serialized.slice(0, TOOL_BODY_MAX_CHARS)}…` };
    }
  }

  const contentType =
    response.headers['content-type']
    || response.headers['Content-Type']
    || null;

  const out = {
    status: response.status,
    status_text: response.status_text,
    time_ms: response.time,
    body,
  };

  if (contentType) out.content_type = contentType;
  if (response.size != null) out.size_bytes = response.size;

  return out;
}
